import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const NoVitalSignIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.02353 2.70446C2.3189 2.31541 2.8613 2.2493 3.23501 2.5568L22.735 18.6017C23.1087 18.9091 23.1722 19.4738 22.8768 19.8628C22.5815 20.2519 22.0391 20.318 21.6654 20.0105L2.16537 3.96565C1.79166 3.65815 1.72815 3.0935 2.02353 2.70446Z"
            fill="currentColor"
         />
         <path
            d="M11.13 2.71073C11.235 2.28911 11.6063 2.00023 12.0225 2.01194C12.4425 2.02365 12.795 2.33206 12.8813 2.75758L15.2632 14.7343L13.0646 12.9301L11.8988 7.06353L10.8782 11.1359L9.33551 9.86987L11.13 2.71073Z"
            fill="currentColor"
         />
         <path
            d="M8.86013 11.7664L8.15625 14.5746L7.14 12.322C6.795 11.5569 6.0525 11.065 5.23875 11.065H0.9C0.40125 11.065 0 11.4827 0 12.0019C0 12.5211 0.40125 12.9388 0.9 12.9388H5.23875C5.355 12.9388 5.46 13.0091 5.50875 13.1184L7.58625 17.7133C7.7475 18.0685 8.1075 18.2832 8.4825 18.2481C8.8575 18.213 9.17625 17.9319 9.27 17.5532L10.4029 13.0325L8.86013 11.7664Z"
            fill="currentColor"
         />
         <path
            d="M13.6075 15.6623L14.7188 21.2541C14.8013 21.6796 15.1538 21.988 15.57 21.9997C15.9863 22.0114 16.3575 21.7303 16.4663 21.3126L17.1863 18.5992L13.6075 15.6623Z"
            fill="currentColor"
         />
         <path
            d="M17.6846 16.7215L18.6263 13.1731C18.6638 13.0364 18.78 12.9427 18.915 12.9427H23.1C23.5988 12.9427 24 12.525 24 12.0058C24 11.4866 23.5988 11.0689 23.1 11.0689H18.915C17.97 11.0689 17.1412 11.7247 16.89 12.6734L16.152 15.4638L17.6846 16.7215Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default NoVitalSignIcon
